import React from 'react';
import './Section_10.css';
import { DynamicIcon } from 'lucide-react/dynamic';


function Section10({ sectionConfig }) {

  // if (!sectionConfig || !sectionConfig.items) return null;

const getLucideIcon = (iconName, size =35) => {
             if (!iconName) return null;
             return <DynamicIcon name={iconName} size={size} />;
           };


  return (
    <section className="section-10">
      <div className="item-section10-grid">
        {sectionConfig.stats.map((item, idx) => (
          <div key={idx} className="item-card">
            <div className="item-icon">{getLucideIcon(item.icon)|| '⭐'}</div>
            <div className="item-title"><strong>{item.title}</strong></div>
            <div className="item-subtitle">{item.description}</div>
            <div className="item-number">{item.number}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Section10;